import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import {countries, devConfig, profile} from 'config/config'; // Importing development configuration

/**
 * FilterTagsView class extends JetView to create a filter interface for tags.
 */
export default class FilterTagsView extends JetView {
    /**
     * Configures the UI components of the FilterTagsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section configuration with input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for Name
                            name: 'Provider',
                            label: "<span class='icon-file-text1'></span>" + _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Proveedor'),
                        },
                        {
                            view: 'text', // Text input for Name
                            name: 'Subprovider',
                            label: "<span class='icon-file-text1'></span>" + _('SubProveedor'),
                            labelPosition: 'top',
                            placeholder: _('SubProveedor'),
                        },
                        {
                            view: 'richselect',
                            name: 'Partner',
                            label: _('Partner'), // Partner label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            value: profile.PartnerSelected, // Default selected partner
                            options: profile.Partners, // Partner options from profile
                            id: 'Partners',
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'Country',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Custom template for dropdown items
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for dropdown
                                },
                            },
                            id: 'Countries',
                        },
                    ],
                },
            ],
        };

        // Upper section configuration containing the first left section
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };


        // Buttons configuration for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to clear inputs
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter tags
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('activeProviders:filter', [filterdata]); // Event call with filter data
                                $$('b1').collapse(); // Collapse accordion
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section configuration for filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Body contains upper sections and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
